import React from 'react';
import Icon from '../../../components/AppIcon';

const AdminActivityFeed = ({ logs, showAll = false }) => {
  const getActionIcon = (actionType) => {
    const icons = {
      blog_create: 'FileText',
      blog_edit: 'Edit',
      blog_publish: 'Upload',
      blog_archive: 'Archive',
      user_view: 'Eye',
      redemption_approve: 'CheckCircle',
      redemption_reject: 'XCircle',
      point_adjustment: 'TrendingUp',
      reward_config: 'Settings'
    };
    return icons?.[actionType] || 'Activity';
  };

  const getActionColor = (actionType) => {
    const colors = {
      blog_publish: 'success',
      redemption_approve: 'success',
      blog_archive: 'warning',
      redemption_reject: 'error',
      point_adjustment: 'primary',
      reward_config: 'accent'
    };
    return colors?.[actionType] || 'muted-foreground';
  };

  const displayLogs = showAll ? logs : logs?.slice(0, 5);

  if (!displayLogs || displayLogs?.length === 0) {
    return (
      <div className="text-center py-32 text-muted-foreground">
        <Icon name="Activity" size={48} className="mx-auto mb-12 opacity-50" />
        <p>No activity logs yet</p>
      </div>
    );
  }

  return (
    <div className="space-y-12">
      {displayLogs?.map((log) => (
        <div key={log?.id} className="flex items-start space-x-12 p-12 hover:bg-muted/30 rounded-lg transition-smooth">
          <div className={`flex items-center justify-center w-10 h-10 bg-${getActionColor(log?.actionType)}/10 rounded-lg flex-shrink-0`}>
            <Icon 
              name={getActionIcon(log?.actionType)} 
              size={16} 
              color={`var(--color-${getActionColor(log?.actionType)})`} 
            />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm text-foreground">{log?.description}</p>
            <div className="flex items-center space-x-12 mt-4">
              <p className="text-xs text-muted-foreground">{log?.adminName || log?.adminEmail}</p>
              <span className="text-xs text-muted-foreground">•</span>
              <p className="text-xs text-muted-foreground">
                {new Date(log?.createdAt)?.toLocaleString()}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminActivityFeed;